import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { AppRoleSummary, AppRoleWithPermissions } from '~/models/administration/approle';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { FormTabSummary } from '~/models/modules/formTab';
import { AppRolesService } from '~/services/administration.ts/approles';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutComponent } from '../../layout/layout.component';

@Component({
    selector: 'asap-edit-forms',
    templateUrl: './edit-forms.component.html',
    styleUrls: ['./edit-forms.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditFormsComponent implements OnInit {

  _theme: string;
  @Output() close = new EventEmitter<boolean>();
  @Output() saved = new EventEmitter();
  @Input() page: string;
  @Input() permissionScope: string;

  object: FormTabSummary[] = [];
  _appRoles: AppRoleWithPermissions[];

  constructor(
    private _themeManager: ThemeManagerService,
    private _gridFieldService: GridFieldsService,
    private _appRolesService: AppRolesService,
    private _layoutComponent: LayoutComponent
  ) {
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
  }

  ngOnInit(): void {
    this.getEditForm();
      this._appRolesService
          .getAppRolesListing()
          
          .subscribe((data: AppRoleWithPermissions[]) => {
            this._appRoles = data;
            });
  }

  closeForm(event: boolean){
    this.close.emit(event);
  }

  getEditForm(){
    this._gridFieldService.getEditForms(this.page)
      
      .subscribe((x: FormTabSummary[]) => {
      this.object = x;
    });
  }

  submit(){
    this._gridFieldService.updateEditForms(this.object)
      .subscribe((x: any) => {
        if(x){
          this.closeForm(false);
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: 'Form Changes Saved Successfully.',
            withoutConfirm: true
        });
          this.saved.emit();
        }
      })
  }


  CheckBoxOnViewChange(data: GridFieldAuthorization, event: boolean){
    if (!event){
      data.canEdit = false;
    }
  }

  CheckBoxOnEditChange(data: GridFieldAuthorization, event: boolean){
    if(event){
      data.canView = true;
    }
  }

  canSetSecurityLevel(operation: string, role: AppRoleSummary) {
    const roleWithPermissions: AppRoleWithPermissions = this._appRoles?.find(r => r.id === role?.id);
    if(roleWithPermissions)
    {
      return roleWithPermissions.permissions.find(p => p.scope === this.permissionScope && p.operation === operation);
    }

  }
}
